var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDierckeStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: ".._.._src_svg_Icn_40px_Diercke_Star__Icn/40px/Diercke_Star",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: ".._.._src_svg_Icn_40px_Diercke_Star__Color/Transp_00",
    opacity: 0
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H40V40H0z",
    id: ".._.._src_svg_Icn_40px_Diercke_Star__Rectangle"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M15.4358126,31.7072897 L21.3701791,24.152193 C21.5115548,23.9724248 21.7389309,23.8829207 21.964919,23.9180801 L31.2195061,25.3581834 C31.5036997,25.4023718 31.7819288,25.2492742 31.8966812,24.9855627 C32.0114335,24.7218513 31.9338161,24.4139249 31.70777,24.2361081 L24.264657,18.3894952 C24.0849143,18.2481024 23.9954239,18.0207528 24.0305644,17.7947853 L25.4482803,8.67908596 C25.4927839,8.39476516 25.3395686,8.11628346 25.0755802,8.00167193 C24.8115917,7.8870604 24.5035039,7.96526573 24.3261485,8.19190843 L18.6258745,15.4443894 C18.4849643,15.6240715 18.257959,15.7135966 18.0323252,15.6784702 L8.67843785,14.2241128 C8.39441654,14.1796396 8.1162034,14.3326151 8.00161898,14.5962618 C7.88703455,14.8599085 7.96500488,15.1676706 8.19130013,15.3449654 L15.5552561,21.1312483 C15.7349874,21.2726494 15.8244752,21.4999922 15.7893487,21.7259582 L14.3136808,31.22008 C14.2695196,31.5042736 14.4227666,31.7824561 14.6865887,31.897003 C14.9504108,32.0115498 15.2583054,31.9335869 15.4358126,31.7072897 L15.4358126,31.7072897 Z",
    id: ".._.._src_svg_Icn_40px_Diercke_Star__Path",
    strokeWidth: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDierckeStar);
export default __webpack_public_path__ + "static/media/Diercke_Star.484143eaadb8d94c40877c46d690d1b8.svg";
export { ForwardRef as ReactComponent };